import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../../utils/rolloutFeatures";
import LegacyPage from "./Legacy";
import RolloutPage from "./Rollout";

const Disparos = props => {
  const { user } = useContext(AuthContext);
  const enabled =
    hasRolloutFeature(user, ROLLOUT_FEATURES.ALL_CONTACTS) ||
    hasRolloutFeature(user, ROLLOUT_FEATURES.BROADCAST_METRICS);
  const Page = enabled ? RolloutPage : LegacyPage;
  return <Page {...props} />;
};

export default Disparos;
